import { render, staticRenderFns } from "./ServerList.vue?vue&type=template&id=d141bf2c&scoped=true"
import script from "./ServerList.vue?vue&type=script&lang=ts"
export * from "./ServerList.vue?vue&type=script&lang=ts"
import style0 from "./ServerList.vue?vue&type=style&index=0&id=d141bf2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d141bf2c",
  null
  
)

export default component.exports